import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import {ReactComponent as MessageIcon} from './SideBarIcons/message.svg'
import {ReactComponent as OrderIcon} from './SideBarIcons/order.svg'

import css from './Sidebar.module.css';

const Sidebar = props => {
  const { className, rootClassName, currentPage, history } = props;

  // Initialize mode from localStorage or default to 'buyer'
  const [mode, setMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('wheelplace_sidebar_mode') || 'buyer';
    }
    return 'buyer';
  });

  const isBuyer = mode === 'buyer';
  const isSeller = mode === 'seller';

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('wheelplace_sidebar_mode', mode);
      localStorage.setItem('buyerSellerMode', mode);
    }
  }, [mode]);
  useEffect(() => {
  const pathname = window.location.pathname;

  if (pathname.includes('/sale') || pathname.includes('/inbox/sales')) {
    setMode('seller');
  } else if (pathname.includes('/order') || pathname.includes('/inbox/orders')) {
    setMode('buyer');
  }
}, [history.location.pathname]);

  const handleToggle = (role) => {
    // Only toggle if the role is different from the current state
    if (mode !== role) {
      // Determine the active route to know whether we need to redirect
      // If the user is currently on an inbox or transaction page, redirect them to the equivalent tab for the selected role
      const pathname = window.location.pathname;
            // Toggle the mode in state
      setMode(role);

      if (pathname.includes('/inbox')) {
        // Redirecting within Inbox
        history.push(`/inbox/${role === 'seller' ? 'sales' : 'orders'}`);
      } else if (pathname.includes('/order') || pathname.includes('/sale')) {
        // Redirecting within Transactions
        history.push(role === 'seller' ? '/sale' : '/order');
      }


    }
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <nav className={classes}>
      <div className={css.toggleContainer}>
        <button
          className={classNames(css.toggleButton, { [css.activeToggle]: isSeller })}
          onClick={() => handleToggle('seller')}
        >
          <FormattedMessage id="Sidebar.seller" />
        </button>
        <button
          className={classNames(css.toggleButton, { [css.activeToggle]: isBuyer })}
          onClick={() => handleToggle('buyer')}
        >
          <FormattedMessage id="Sidebar.buyer" />
        </button>
      </div>

      <ul className={css.navList}>
        <li className={css.navItem}>
          <NamedLink
            name="InboxPage"
            params={{ tab: isSeller ? 'sales' : 'orders' }}
            className={classNames(css.navLink, {
              [css.activeNavLink]: currentPage === 'InboxPage',
            })}
          >
            <MessageIcon className={css.navIcon} />
            <span className={css.navText}>
              <FormattedMessage id="Sidebar.messages" />
            </span>
          </NamedLink>
        </li>
        <li className={css.navItem}>
          <NamedLink
            name={isSeller ? "SalePage" : "OrderPage"}
            params={{}}
            className={classNames(css.navLink, {
              [css.activeNavLink]: currentPage === 'TransactionPage',
            })}
          >
            <OrderIcon className={css.navIcon} />
            <span className={css.navText}>
              {isSeller ? (
                <FormattedMessage id="Sidebar.orders" />
              ) : (
                <FormattedMessage id="Sidebar.purchases" />
              )}
            </span>
          </NamedLink>
        </li>
      </ul>
    </nav>
  );
};

Sidebar.defaultProps = {
  className: null,
  rootClassName: null,
  currentPage: null,
};

Sidebar.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string,
};

export default withRouter(Sidebar);
